import { AfterViewInit, Component, Input } from '@angular/core';
import { RegistrationService } from '../../../services/registration.service';
import { PaypalService } from '../../../services/paypal.service';

declare const bootstrap: any; 

@Component({
    selector: 'app-paypal-order',
    imports: [],
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.css']
})
export class PaypalOrderComponent implements AfterViewInit {
  @Input() registrationId: string | null = null;
  paymentDetails: any = null;

  planId: string = "";
  product: any = null;
  plan: any = null;

  price: string = '';
  currency: string = '';
  

  constructor(
    private registrationService: RegistrationService,
    private paypalService: PaypalService
  ) {}

  async ngOnInit(): Promise<void> {
    // 1️⃣ Fetch products
    const products = await this.paypalService.getAllProducts();
    if (!products?.length) return;

    for (let i = products.length - 1; i >= 0; i--) {
      const product = products[i];
      if (!product?.id) continue;

      // 2️⃣ Fetch ACTIVE plans
      const plans = (await this.paypalService.getPlansByProduct(product.id))
        ?.filter(p => p.status?.toUpperCase() === "ACTIVE");

      if (!plans?.length) continue;

      this.product = product;
      this.plan = plans[plans.length - 1];
      this.planId = this.plan.id;
      break;
    }

    if (!this.planId) {
      console.error("No active plan found.");
      return;
    }

    // 3️⃣ Extract plan price
    const fullPlan = await this.paypalService.getPlanDetails(this.planId);
    const billing = fullPlan.billing_cycles?.find((b: any) => b.tenure_type === "REGULAR")
                  || fullPlan.billing_cycles?.[0];

    const fixedPrice = billing?.pricing_scheme?.fixed_price;
    if (fixedPrice) {
      this.price = fixedPrice.value;
      this.currency = fixedPrice.currency_code;
    }
  }

  ngAfterViewInit(): void {
    const wait = setInterval(() => {
      if (this.planId && (window as any).paypal) {
        clearInterval(wait);
        this.renderSubscriptionButton();
      }
    }, 200);
  }

  renderSubscriptionButton() {
    const paypal = (window as any).paypal;
    if (!paypal || !paypal.Buttons) {
      console.error("PayPal SDK not loaded.");
      return;
    }

    paypal.Buttons({
      //Only subscription mode
      createSubscription: (_: any, actions: any) => {
        return actions.subscription.create({
          plan_id: this.planId
        });
      },

  onApprove: async (data: any) => {
  console.log("Subscription Approved:", data);
  const subscriptionDetails: any = await this.paypalService.getSubscriptionDetails(data.subscriptionID);
  const realStatus = subscriptionDetails?.status || "UNKNOWN";
  const email = subscriptionDetails?.subscriber?.email_address || null;
  const firstName = subscriptionDetails?.subscriber?.name?.given_name || "";
  const lastName = subscriptionDetails?.subscriber?.name?.surname || "";
  const payerId = subscriptionDetails?.subscriber?.payer_id || data.payerID;
  const lastPaymentAmount = subscriptionDetails?.billing_info?.last_payment?.amount;
  const cycle = subscriptionDetails.plan?.billing_cycles?.[0]?.pricing_scheme?.fixed_price;
  const amountValue = lastPaymentAmount?.value ?? cycle?.value ?? null;
  const currency    = lastPaymentAmount?.currency_code ?? cycle?.currency_code ?? null;
  this.paymentDetails = {
    ...subscriptionDetails,
    extractedAmount: amountValue,
    extractedCurrency: currency
  };
        // Save subscription in backend
        this.registrationService.update(this.registrationId!, {
          subscriptions: [
            {
              paypal: {
                email: email,
                name: firstName + " " + lastName,
                orderId: data.id,
                subscriptionId: data.subscriptionID,
                payerId:payerId,
                planId: this.planId,
                status: realStatus,
                amount: amountValue,  
                currency: currency,  
                date: new Date().toISOString(),
              },
            },
          ],
        } as any).subscribe({
          next: res => console.log("Subscription saved:", res),
          error: err => console.error("Failed to save subscription:", err)
        });
        const modalEl = document.getElementById("paymentModal");
        if (modalEl) {
          const modal = new bootstrap.Modal(modalEl);
          modal.show();
        }
      },

      onError: (err: any) => {
        console.error("PayPal Error:", err);
        alert("Subscription failed. Please try again.");
      }
    }).render("#paypal-button-container");
  }
}
